// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3xvlM","alertIcon":"ConfirmModal_alertIcon__h6eXM"};